<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" [formGroup]="formGroup">
  <div class="form-group col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <label for="{{controlId}}" class="control-label" *ngIf="showLabel">
      <span *ngIf="!label" i18n="@@password">Password</span>
      <span *ngIf="label">{{label}}</span>&nbsp;<span *ngIf="showRequired && required">*</span>
    </label>

    <div class="input-group-icon input-group-icon-right">
      <button class="input-icon input-icon-right" (click)="showPassword($event)">
        <em class="ti-eye"></em>
      </button>

      <input id="{{controlId}}" [type]="inputType" class="form-control" [formControlName]="controlName"
             [readOnly]="readonly" [class.is-valid]="showValid" [class.is-invalid]="showInvalid" autocomplete="current-password"
             (keypress)="keypress($event)" (change)="onChange($event)"/>

      <div *ngIf="showInvalid" class="invalid-feedback">
        <div *ngIf="control?.hasError('required')" i18n="@@requiredInput">This input is required.</div>
        <div *ngIf="control?.hasError('minlength') && !onlyRequiredError" i18n="@@passwordMinLen">
          6 chars are required for password
        </div>
        <div *ngIf="control?.hasError('mustMatch') && !onlyRequiredError" i18n="@@passwordConfirmMustMatch">
          Password and password confirmation must match
        </div>
      </div>
    </div>
  </div>
</div>
